import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {SessionService} from '../services/session.service';
import {DataStore} from "@aws-amplify/datastore";
import {Bonus, BonusStatus} from '../../models';

@Component({
  selector: 'app-edit-bonus',
  templateUrl: './edit-bonus.page.html',
  styleUrls: ['./edit-bonus.page.scss'],
})
export class EditBonusPage implements OnInit {
  @Input() bonusId: string;
  public currentBonus;
  public bonusForm: UntypedFormGroup;
  public bonusStatus = BonusStatus;
  public statusList: any[]; // No way to use Object.values in template...

  constructor(
    public sessionService: SessionService,
    public fb: UntypedFormBuilder,
    public modalController: ModalController,
  ) {
    this.bonusForm = this.fb.group({
      'type': [''],      
      'status': ['']      
    });
    
    this.statusList =  Object.values(this.bonusStatus);
  }

  async ngOnInit() {
    this.currentBonus = this.bonusId ? await DataStore.query(Bonus, this.bonusId) : null;
    
    this.bonusForm.setControl('type', new UntypedFormControl(this.currentBonus?.type));
    this.bonusForm.setControl('status', new UntypedFormControl(this.currentBonus?.status));    
  }

  async updateBonus() {
    const original = await DataStore.query(Bonus, this.currentBonus.id);
    
    DataStore.save(Bonus.copyOf(original, updated => {
        updated.type = this.bonusForm.value.type;
        updated.status =  this.bonusForm.value.status;        
    }));

    this.modalController.dismiss();
  }

}
